class CustomSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.customSearchResults = this.querySelector('#custom-search');
    this.closeBtn = this.querySelector('.cm-btn--close-search');
    this.headerWrapper = this.closest('.header-wrapper').querySelector('.cm-header-menu__list');
    document.addEventListener('custom-search:open', e => {
      this.input.value = '';
      this.classList.add('cm-active');
      this.headerWrapper.classList.add('menu-hide');
      setTimeout(() => { this.input.focus(); }, 100);
    });
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.closeBtn.addEventListener('click', e => { e.preventDefault(); this.close(); });
    document.addEventListener('custom-search:close', () => { this.close(); });
    document.addEventListener('keydown', (event) => { if (event.keyCode === 27) this.close(); });
    document.addEventListener('click', (event) => {
      if (!this.classList.contains('cm-active')) return;
      if (event.target.closest('custom-search')) return;
      this.close();
    }, { capture: true });
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) return;
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const searchObj = {
      'q': searchTerm,
      'resources[limit]': 3,
      'resources[limit_scope]': 'each',
      'resources[options][unavailable_products]': 'last'
    };

    const params = this.paramUrl(searchObj);

    fetch(`${theme.routes.customSearch}?${params}&section_id=search-results`)
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-results').innerHTML;
        this.customSearchResults.innerHTML = resultsMarkup;
        this.open();

        AOS.refreshHard();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.customSearchResults.style.display = 'block';
  }

  close() {
    this.customSearchResults.style.display = 'none';
    this.customSearchResults.innerHTML = '';
    this.input.value = '';
    this.classList.remove('cm-active');
    this.headerWrapper.classList.remove('menu-hide');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  paramUrl(obj) {
    return Object.keys(obj).map(function(key) {
      return key + '=' + encodeURIComponent(obj[key]);
    }).join('&')
  }
}

customElements.define('custom-search', CustomSearch);

class HeaderSection {
  constructor () {
    this.cmHeader = document.querySelector('.cm-header-layout');
    if (!this.cmHeader) return;
    this.init();
  }
  init () {
    document.querySelectorAll('.js-custom-search-header').forEach(btn => {
      btn.addEventListener('click', function(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        document.dispatchEvent(new CustomEvent('custom-search:open'));
      });
    });
    document.querySelectorAll('.cm-mobile_nav_item').forEach(item => {
      const nav = item.closest('.cm-mobile_nav');
      if (!nav) return;
      const inner = nav.querySelector('.cm-mobile_inner');
      if (!inner) return;
      item.addEventListener('click', (evt) => {
        inner.classList.add('cm-active');
      });
    });
    document.querySelectorAll('.cm-mobile_inner_title').forEach(item => {
      item.addEventListener('click', (evt) => {
        item.closest('.cm-mobile_inner').classList.remove('cm-active');
      });
    });
    document.querySelectorAll('.cms_down_item_title').forEach(item => {
      item.addEventListener('click', (evt) => {
        item.closest('.cms_down_items').classList.toggle('cm-active');
      });
    });
  }
}
new HeaderSection();

class CmSlideShow extends HTMLElement {
  constructor() {
      super();
      this.slideshow = this.querySelector('.cm-hero');
      if (!this.slideshow) { return }
      this.initialIndex = 0;
      this.cm_flickity = null
      this.defaults = {
        fade: false,
        setGallerySize: false,
        wrapAround: true,
      }
      this.init();
  }
  loadSlideImgs (url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = url;
      img.onload = () => resolve();
      img.onerror = () => resolve();
    });
  }
  init() {
    const slides = this.slideshow.querySelectorAll('.cm-slideshow__slide');
    if (this.cm_flickity && typeof this.cm_flickity.destroy === 'function') {
      this.cm_flickity.destroy();
      this.cm_flickity = null;
    }
    if (slides.length > 1) {
      const { autoplay, speed } = this.slideshow.dataset;
      const auto_play = autoplay === 'true' ?  parseInt(speed) : false
      var sliderArgs = {
        ...this.defaults,
        prevNextButtons: this.slideshow.hasAttribute('data-arrows'),
        pageDots: this.slideshow.hasAttribute('data-dots'),
        initialIndex: this.initialIndex,
        autoPlay: auto_play
      };
      const images = this.slideshow.querySelectorAll('.cm-slideshow__slide+.cm-slideshow__slide .cm-hero__image-wrapper img');
      const fetchImages = [...images].map((img) => {
        return this.loadSlideImgs(img.currentSrc);
      });
      Promise.all(fetchImages).then(() => {
        this.cm_flickity = new Flickity(this.slideshow, sliderArgs);
      })
    } else {
      this.slideshow.querySelector('.cm-slideshow__slide').classList.add('is-selected');
    }
  }
}
customElements.define('cm-slide-show', CmSlideShow);

class CmMeasurementFinder extends HTMLElement {
  constructor() {
    super();
    this.eventHandler();

  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  bindClickHandler(name, cb) {
    document.querySelectorAll(name).forEach((target) => {
      target.addEventListener('click', (evt) => {
        evt.preventDefault();
        cb(target)
      })
    });
  }
  prevNexStep(target) {
    let step = target.dataset.step*1;
    if (step === 6){ this.computedSize(); }
    target.closest('.cm-measurement-step').classList.remove('step-active');
    document.querySelector(`.cm-measurement-step-${step}`).classList.add('step-active');
  }
  listenerInput(target) {
    const inputValue = target.value;
    const wrapper = target.closest('.cms_step');
    const fields = wrapper.querySelectorAll('.cms_step_field_input');
    const btn = wrapper.querySelector('.cms_step_btn');
    const fieldsValueIsNotEmpty = [...fields].every((field) => {
      const minValue = Number(field.min) || 0;
      if (field.value && field.value * 1 > 0) {
        return minValue <= 0 ? true : minValue <= field.value * 1
      }  else {
        return false;
      }
    });
    const minTarget = Number(target.min) || 0;
    if (minTarget > 0 && inputValue < minTarget) {
      target.classList.add('input-error');
    } else if (inputValue <= 0) {
      target.classList.add('input-error');
    } else {
      target.classList.remove('input-error');
    }
    fieldsValueIsNotEmpty ? btn.classList.remove('cms_step_hide') : btn.classList.add('cms_step_hide');
  }
  computedSize() {
    const sideType = this.querySelector('.cm-measurement-content').classList.contains('inside')? 'inside' : 'outside';
    if (sideType === 'inside') {
      const widthInput = this.querySelectorAll('.cms_step2_inside .cms_step_field_input');
      const heightInput = this.querySelectorAll('.cms_step3_inside .cms_step_field_input');
      const insideWidths = [...widthInput].map((target) => parseFloat(target.value));
      const insideHeights = [...heightInput].map((target) => parseFloat(target.value));
      const insideWidth = Math.max(Math.min(...insideWidths) - 3/8, 0) ;
      const insideHeight = Math.max(...insideHeights);
      this.querySelector('.cms_measurement_result').textContent = `${insideWidth}"W × ${insideHeight}"L`;
    }
    if (sideType === 'outside') {
      const widthInput = this.querySelector('.cms_step2_outside .cms_step_field_input');
      const widthOtherInputLeft = this.querySelector('.cms_step3_outside .cms_step_field_input_left');
      const widthOtherInputRight = this.querySelector('.cms_step3_outside .cms_step_field_input_right');
      const heightInput = this.querySelector('.cms_step4_outside .cms_step_field_input');
      const heightOtherInput = this.querySelector('.cms_step5_outside .cms_step_field_input');
      const outsideWidth = parseFloat(widthInput.value) + parseFloat(widthOtherInputLeft.value) + parseFloat(widthOtherInputRight.value);
      const outsideHeight = parseFloat(heightInput.value) + parseFloat(heightOtherInput.value);
      this.querySelector('.cms_measurement_result').textContent = `${outsideWidth}"W × ${outsideHeight}"L`;
    }
  }
  eventHandler() {
    this.bindClickHandler('.cm-measurement-prev-btn', (target) => {
      this.prevNexStep(target);
    })
    this.bindClickHandler('.cm-measurement-step1-half', (target) =>  {
      const side = target.dataset.side;
      target.closest('.cm-measurement-content').classList.remove('inside', 'outside');
      target.closest('.cm-measurement-content').classList.add(side);
      this.prevNexStep(target);
    })
    this.bindClickHandler('.cms_step_btn', (target) => {
      this.prevNexStep(target);
    })
    document.querySelectorAll('.cms_step_field_input').forEach((input) => {
      input.addEventListener('input', this.debounce((event) => {
        this.listenerInput(event.target)
      }, 300))
    });
    document.querySelector('.cms_step_reset').addEventListener('click', () => {
      window.location.reload();
    })
  }
}
customElements.define('cm-measurement-finder', CmMeasurementFinder);

class RichTextMore {
  constructor() {
    const btns = document.querySelectorAll('.cm-read-more-btn span');
    if (!btns.length) return;
    btns.forEach((target) => {
      target.addEventListener('click', () => {
        const wrapper = target.closest('.cm-read-more');
        const type = target.dataset.type;
        if (type === 'more') {
          wrapper.classList.add('expand');
        }
        if (type === 'less') {
          wrapper.classList.remove('expand');
        }
      });
    })
  }
}
new RichTextMore();

class CustomCmEvent {
  constructor() {
    this.openFooterFirst();
  }
  openFooterFirst() {
    // default open footer first
    const footInner = document.querySelector('.cm-footer-inner .collapsible-content__inner');
    if (!footInner) return;
    const content = footInner.closest('.collapsible-content');
    content.style.height = `${footInner.offsetHeight}px`;
  }
};
new CustomCmEvent();

class CustomAnchor {
  constructor() {
    this.tradePartner();
  }
  // /pages/trade-partner
  tradePartner() {
    const anchors = document.querySelectorAll('cm-slide-show .btn--inverse, .feature-row .appear-delay-2 .btn');
    const targetAnchor = document.querySelector('.globo-formbuilder');
    for (const anchor of anchors) {
      anchor.addEventListener('click', (event) => {
        event.preventDefault();
        targetAnchor.scrollIntoView({
          behavior: 'smooth'
        });
      });
    }
  }
}
new CustomAnchor();

class CmProductAnchor extends HTMLElement {
  constructor() {
    super();
    this.anchors = this.querySelectorAll('.cm-anchor');
    this.stickyHeight = 140;
    this.stickyMobileHeight = 90;
    this.ViewSet = new Set();
    if (window.innerWidth > 769) {
      this.initPcAnchor();
    } else {
      this.initMobileAnchor();
    }
  }

  initMobileAnchor() {
    this.querySelector('.cm-anchors-select').addEventListener('change', (event) => {
      const target = event.target;
      const value = target.value;
      target.blur();
      if (!value) return;
      const targetAnchor = document.querySelector(`.${value}`);
      if (!targetAnchor) return;
      targetAnchor.style.scrollMarginTop = `${this.stickyMobileHeight}px`
      targetAnchor.scrollIntoView({ behavior: 'smooth' });
      setTimeout(() => {
        const firstAnchor = this.querySelector('.cm-anchors-select').querySelector('option');
        target.value = firstAnchor.value;
      }, 300);
    })
  }
  initPcAnchor() {
    this.anchors.forEach((target) => {
      const { anchorName } = target.dataset;
      if (!anchorName) return;
      const targetAnchor = document.querySelector(`.${anchorName}`);
      if (!targetAnchor) return;
      this.initCLickEvent(target, targetAnchor);
      this.initObserverAnchor(target, targetAnchor);
    });
  }
  initCLickEvent(target, targetAnchor) {
    target.addEventListener('click', (event) => {
      targetAnchor.style.scrollMarginTop = `${this.stickyHeight}px`
      targetAnchor.scrollIntoView({ behavior: 'smooth' });
    });
  }
  changeActive() {
    // console.log(this.ViewSet.size);
    const anchorsActive = this.querySelectorAll('.cm-anchor.active');
    for (const anchor of anchorsActive) {
      anchor.classList.remove('active');
    };
    let targetSet = null;
    for (const view of this.ViewSet) {
      if (!targetSet) {
        targetSet = view;
      } else if (view.dataset.index < targetSet.dataset.index) {
        targetSet = view;
      }
    }
    targetSet && targetSet.classList.add('active');
  }
  initObserverAnchor(target, targetAnchor) {
    const observerAnchor = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        !entry.isIntersecting ? this.ViewSet.delete(target) : this.ViewSet.add(target);
        this.changeActive();
      });
    }, { rootMargin: `-${this.stickyHeight}px 0px 0px 0px` });
    observerAnchor.observe(targetAnchor);
  }
}
customElements.define('cm-product-anchor', CmProductAnchor);

class CmTextColumns {
  constructor() {
    const columns = document.querySelectorAll('.cm-columns-lists');
    for (const column of columns) {
      const slideTotal = column.querySelectorAll('.cm-columns-list').length;
      if (slideTotal > 3) {
        const ColumnFlickity = new Flickity(column, {
          freeScroll: true,
          contain: true,
          pageDots: false,
          percentPosition: true,
          cellAlign: 'left',
          on: {
            change: (index) => {
              let lastIndex = window.innerWidth > 769 ? slideTotal - 3 : slideTotal - 1;
              const nextBtn = column.querySelector('.flickity-next');
              // console.log('change', nextBtn, slideTotal, index, lastIndex);
              if (index > lastIndex) {
                ColumnFlickity.select(lastIndex);
              }
              if (!nextBtn) return;
              if (index === lastIndex) {
                nextBtn.disabled = true;
              }
              if (index < lastIndex) {
                nextBtn.disabled = false;
              }
            }
          }
        });
        const title = column.querySelector('.cm-columns-list__title');
        new ResizeObserver(theme.utils.debounce(300, () => {
          // console.log('resize');
          ColumnFlickity.resize();
        })).observe(title);
      }
    }
  }
}
new CmTextColumns();
